export const nhaCungCap = {
  sections: {
    list: { title: '供应商' },
    general: '基本信息',
  },
  stats: {
    total: '共 {count}',
    activeOnPage: '启用（本页）: {count}',
    inactiveOnPage: '停用（本页）: {count}',
  },
  fields: {
    code: '编码',
    name: '名称',
    classification: '分类',
    phone: '电话',
    email: '邮箱',
    address: '地址',
    province: '省/市',
    area: '区域',
    ward: '坊/乡',
    groups: '分组',
    groupCode: '分组编码',
    groupName: '分组名称',
    note: '备注',
    companyName: '公司名',
    taxCode: '税号',
    totalPurchase: '总采购',
    debt: '当前应付',
    totalPurchaseNet: '净采购',
    branch: '分支',
    createdBy: '创建人',
    onOffAction: '开 / 关',
    status: '状态',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  aria: {
    columnPicker: '选择显示列',
  },
  status: { dangHoatDong: '启用', ngungHoatDong: '停用', all: '全部' },
  sort: { maNhaCungCap: '编码', tenNhaCungCap: '名称', ngayTao: '创建日', trangThai: '状态' },
  filter: {
    searchPlaceholder: '搜索',
    textDetailTitle: '详细筛选',
    group: '分组',
    statusSection: '状态',
    groupSection: '供应商分组',
    sortSection: '排序',
    sortField: '排序字段',
    sortDir: '方向',
  },
  titles: { add: '新增供应商', edit: '编辑供应商', detail: '供应商详情' },
  placeholders: {
    codeAuto: '自动生成',
    province: '选择省/市',
    ward: '选择坊/社',
  },
  validation: {
    nameRequired: '请输入供应商名称',
    phoneInvalid: '电话无效（8–15 位数字）',
    emailInvalid: '邮箱无效',
    taxCodeInvalid: '税号无效（10 或 13 位数字）',
  },
  messages: {
    noData: '暂无数据',
    loadError: '加载失败',
    loadDetailError: '详情加载失败',
    createSuccess: '已创建',
    updateSuccess: '已更新',
    deleteSuccess: '已删除',
    toggleSuccess: '状态已更新',
    confirmDelete: '删除供应商 «{name}»？',
    listSummary: '共 {count} 家供应商',
    selectedCount: '已选：{count}',
    deleteSelected: '删除已选（{count}）',
    bulkDeleteConfirm: '删除已选的 {count} 家供应商？（逐条调用删除接口。）',
    bulkDeleteSuccess: '已删除 {count} 家供应商',
    bulkDeletePartial: '已删除 {ok}/{total}。{failed} 家未能删除。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '尚未选择要删除的供应商',
  },
  import: {
    description: '按模板选择 Excel 文件，由服务器处理导入。',
    success: '供应商导入成功',
    failed: '供应商导入失败',
    capNhatDuNoCuoi: '更新期初欠款',
  },
  detailTabs: {
    generalInfo: '信息',
    debt: '应付',
  },
  expandDebt: {
    hint: '应付交易记录将在此显示。',
  },
}
